function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { AdBreakTimeAdapter } from '../../../players/bolt-ons/ad-break-time-adapter';
import { SessionSideThumbnailInfoUtils } from '../../../players/bolt-ons/session-side-thumbnail-info-utils';
import { AdBreakType, SsaiStitcherType } from '../common';
import { CoreVideoInternal } from '../../../core-video-internal';
export var ServerAdvertsAddon = /*#__PURE__*/ function() {
    "use strict";
    function ServerAdvertsAddon(playbackType) {
        _class_call_check(this, ServerAdvertsAddon);
        _define_property(this, "playbackType", void 0);
        _define_property(this, "name", void 0);
        _define_property(this, "playoutOptions", void 0);
        _define_property(this, "isInitialPositionAdjustmentRequired", void 0);
        _define_property(this, "ADVERTS_AVAILABLE_TIMEOUT", void 0);
        _define_property(this, "session", void 0);
        _define_property(this, "currentAdBreak", void 0);
        _define_property(this, "currentAdBreakId", void 0);
        _define_property(this, "adBreakTimeAdapter", void 0);
        _define_property(this, "sessionSideThumbnailInfoUtils", void 0);
        _define_property(this, "vacAddon", void 0);
        _define_property(this, "advertising", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "isInCSAIPreRoll", void 0);
        this.playbackType = playbackType;
        this.name = 'ServerAdvertsAddon';
        this.isInitialPositionAdjustmentRequired = false;
        this.ADVERTS_AVAILABLE_TIMEOUT = 5000;
        this.currentAdBreak = null;
        this.currentAdBreakId = null;
        this.isInCSAIPreRoll = function(currentAdBreak) {
            // We pass the current ad break as an argument since not all sub-classes of ServerAdvertsAddon
            // have the same implementation of current adBreak memory
            if (!currentAdBreak || !CoreVideoInternal.playerCapabilities.supportsNativeCsai) {
                return false;
            }
            return currentAdBreak.type === AdBreakType.Preroll && currentAdBreak.ssaiStitcherType === SsaiStitcherType.None;
        };
        this.adBreakTimeAdapter = new AdBreakTimeAdapter(playbackType);
        this.sessionSideThumbnailInfoUtils = new SessionSideThumbnailInfoUtils(this.adBreakTimeAdapter);
    }
    _create_class(ServerAdvertsAddon, [
        {
            key: "advertisingData",
            get: function get() {
                return this.advertising;
            }
        },
        {
            key: "prepareAdvertising",
            value: /**
     * Perform any work to be done post initialization but before
     * the modified playout is retrieved. Anything in this method
     * should be considered prefetch safe
     * @param playout
     */ function prepareAdvertising(requestOptions) {
                var _this = this;
                return _async_to_generator(function() {
                    return _ts_generator(this, function(_state) {
                        if (!_this.vacAddon) {
                            _this.logger.warn('Vac addon not initialised yet');
                            return [
                                2,
                                Promise.resolve(null)
                            ];
                        }
                        return [
                            2,
                            _this.vacAddon.fetchVacResponse(requestOptions)
                        ];
                    });
                })();
            }
        },
        {
            key: "setAdvertising",
            value: function setAdvertising(advertising) {
                this.advertising = advertising;
            }
        },
        {
            key: "getSessionSideThumbnailInfoUtils",
            value: function getSessionSideThumbnailInfoUtils() {
                return this.sessionSideThumbnailInfoUtils;
            }
        },
        {
            key: "setVacAddon",
            value: function setVacAddon(vacAddon) {
                this.vacAddon = vacAddon;
            }
        },
        {
            key: "getAdBreakTimeAdapter",
            value: function getAdBreakTimeAdapter() {
                return this.adBreakTimeAdapter;
            }
        },
        {
            key: "handlePositionChange",
            value: function handlePositionChange(timeIncludingAds) {
                var _this_getAdEventsManager;
                if (this.currentAdBreakId || this.currentAdBreak || ((_this_getAdEventsManager = this.getAdEventsManager()) === null || _this_getAdEventsManager === void 0 ? void 0 : _this_getAdEventsManager.getCurrentAdBreak())) {
                    var adPosition = this.adBreakTimeAdapter.timeIncludingAdsToAdPosition(timeIncludingAds);
                    if (adPosition) {
                        var _this_session;
                        (_this_session = this.session) === null || _this_session === void 0 ? void 0 : _this_session.notifyAdPositionChanged(adPosition);
                    }
                }
            }
        },
        {
            key: "insertSsaiStitcherType",
            value: function insertSsaiStitcherType(playoutData) {
                return _object_spread_props(_object_spread({}, playoutData), {
                    adInsertionConfig: _object_spread_props(_object_spread({}, playoutData.adInsertionConfig), {
                        ssaiStitcherType: this.getSsaiStitcherType()
                    })
                });
            }
        }
    ]);
    return ServerAdvertsAddon;
}();

//# sourceMappingURL=server-adverts-addon.js.map